import Buttons from "./Buttons";
import Fields from "./Fields";
import Labels from "./Labels";
import Validations from "./Validations";

const UsersLang = {
  Buttons,
  Fields,
  Labels,
  Validations,
};

export default UsersLang;
